/* ============================================================
   TENUTA GRIECI · tg-upgrades.js
   0) Loader-once (rimosso 19/10/2026, il loader non c'è più)  1) Perf mobile  2) Tab bar (LumaBar→Maison)
   3) AJAX add-to-cart → sheet (checkout | carrello)  4) Sticky buy bar
   5) Menu vivo  6) Meteo compatto mobile  7) Header sfondo allo scroll
   8) Zoom guard (pinch / ctrl+wheel)
   ============================================================ */
(function(){
  'use strict';
  var coarse=matchMedia('(hover:none),(pointer:coarse)').matches;
  var mql=matchMedia('(max-width:950px)');
  function isMobile(){return mql.matches;}

  if(coarse||isMobile()){
    var dg=document.getElementById('dotgrid');
    if(dg&&dg.parentNode)dg.parentNode.removeChild(dg);
    document.documentElement.classList.add('is-touch');
  }

  var CFG={};
  try{CFG=JSON.parse(document.getElementById('tg-routes').textContent)||{};}catch(e){CFG={};}
  var L=CFG.labels||{};
  var ROOT=(CFG.root||'/').replace(/\/$/,'');

  /* Registrato SUBITO, non in DOMContentLoaded: deve precedere i listener
     wheel di theme.js e di Lenis. */
  try{initZoomGuard();}catch(e){}

  document.addEventListener('DOMContentLoaded',function(){
    try{buildTabbar();}catch(e){}
    try{enhanceMenu();}catch(e){}
    try{ajaxAtc();}catch(e){}
    try{buildBuybar();}catch(e){}
    try{compactWeatherMobile();}catch(e){}
    try{initScrollHeader();}catch(e){}
  });

  function el(tag,cls,html){var e=document.createElement(tag);if(cls)e.className=cls;if(html!=null)e.innerHTML=html;return e;}

  /* ---------- 8 · ZOOM GUARD ----------
     A) Ctrl+wheel (zoom da trackpad/tastiera). theme.js ha un listener
        wheel {passive:false} che, quando |deltaX|>|deltaY|, chiama
        preventDefault() e spinge Lenis con scrollTo({immediate:true}).
        Il pinch del trackpad genera wheel con ctrlKey=true e deltaX
        rumoroso → lo zoom del browser viene annullato e Lenis riceve
        centinaia di scrollTo immediati: la pagina si inchioda.
        Qui lo intercettiamo in fase di CAPTURE e fermiamo la propagazione
        prima che theme.js/Lenis lo vedano. Nessun preventDefault: lo zoom
        nativo torna a funzionare.
     B) Pinch-zoom su mobile. Lenis riscrive lo scroll e ScrollTrigger tiene
        misure in cache sul layout viewport; quando il visual viewport
        cambia scala le due cose divergono e il pin resta incastrato.
        Mettiamo Lenis in pausa finché scale>1 e refresh di ScrollTrigger
        al ritorno a scale 1. */
  function initZoomGuard(){
    window.addEventListener('wheel',function(e){
      if(e.ctrlKey)e.stopImmediatePropagation();
    },{capture:true,passive:true});

    var vv=window.visualViewport;
    if(!vv)return;
    var zoomed=false,tmr=null;
    function sync(){
      var now=vv.scale>1.01;
      if(now!==zoomed){
        zoomed=now;
        document.documentElement.classList.toggle('tg-zoomed',zoomed);
        var l=window.__lenis;
        if(l){try{zoomed?l.stop():l.start();}catch(e){}}
      }
      clearTimeout(tmr);
      tmr=setTimeout(function(){
        if(zoomed)return;
        try{if(window.ScrollTrigger&&ScrollTrigger.refresh)ScrollTrigger.refresh();}catch(e){}
        moveGlow(currentTab());
      },200);
    }
    vv.addEventListener('resize',sync);
    vv.addEventListener('scroll',sync);
  }

  var ICON={
    home:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 11.2 12 4.8l8 6.4"/><path d="M6.4 10.4v8.8h11.2v-8.8"/></svg>',
    collection:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 2.8h4"/><path d="M11.2 2.8v3.3c0 .8-2.7 1.6-2.7 3.6v9.7c0 1 .8 1.8 1.8 1.8h3.4c1 0 1.8-.8 1.8-1.8V9.7c0-2-2.7-2.8-2.7-3.6V2.8"/></svg>',
    search:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="6.2"/><path d="M20.4 20.4l-4.6-4.6"/></svg>',
    cart:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6.4 8.4h11.2l-.9 11.2H7.3z"/><path d="M9.2 8.4V7a2.8 2.8 0 0 1 5.6 0v1.4"/></svg>'
  };

  /* request.page_type vale anche 'customers/account', 'customers/login',
     'customers/order', 'customers/addresses'… Prima cadevano tutte nel
     ramo else e accendevano "Maison": su una sessione account la tab bar
     indicava una pagina in cui non eri. Ora nessuna tab è attiva e la
     retroilluminazione si spegne. */
  function activeKey(){
    var t=CFG.template||'';
    if(t.indexOf('customers')===0)return'';
    if(t==='cart')return'cart';
    if(t==='search')return'search';
    if(t==='collection'||t==='product'||t==='list-collections')return'collection';
    if(t==='index')return'home';
    return'';
  }
  var badgeEl=null,glowEl=null,barEl=null;
  function currentTab(){return barEl?barEl.querySelector('[aria-current="true"]'):null;}

  function buildTabbar(){
    if(document.querySelector('.tg-tabbar'))return;
    var items=[
      {k:'home',href:CFG.root||'/',label:L.home||'Maison'},
      {k:'collection',href:CFG.collection||'/collections/all',label:L.collection||'Collection'},
      {k:'search',href:CFG.search||'/search',label:L.search||'Search'},
      {k:'cart',href:CFG.cart||'/cart',label:L.cart||'Cart'}
    ];
    var bar=el('nav','tg-tabbar');bar.setAttribute('aria-label','Mobile navigation');
    barEl=bar;
    glowEl=el('span','tg-tabbar__glow');bar.appendChild(glowEl);
    var act=activeKey();
    items.forEach(function(it){
      var a=el('a','tg-tabbar__btn',ICON[it.k]+'<span>'+it.label+'</span>');
      a.href=it.href;
      if(it.k===act)a.setAttribute('aria-current','true');
      if(it.k==='cart'){
        badgeEl=el('i','tg-tabbar__badge');
        var n=CFG.cartCount||0;badgeEl.textContent=n;badgeEl.style.display=n>0?'flex':'none';
        a.appendChild(badgeEl);
      }
      bar.appendChild(a);
    });
    document.body.appendChild(bar);

    /* Posizione iniziale SENZA transizione: .is-ready abilita l'animazione
       solo dopo il primo frame. */
    moveGlow(currentTab());
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){bar.classList.add('is-ready');});
    });

    var rt=null;
    function onResize(){clearTimeout(rt);rt=setTimeout(function(){moveGlow(currentTab());},120);}
    window.addEventListener('resize',onResize);
    window.addEventListener('orientationchange',onResize);
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(function(){moveGlow(currentTab());});

    bar.addEventListener('click',function(e){
      var b=e.target.closest('.tg-tabbar__btn');
      if(b)moveGlow(b);
    });
  }

  /* Custom property dentro un translate3d: resta su compositor, niente
     reflow per frame come con `left`. */
  function moveGlow(btn){
    if(!glowEl)return;
    if(!btn){glowEl.style.opacity='0';return;}
    glowEl.style.opacity='';
    var bar=btn.parentElement,r=btn.getBoundingClientRect(),br=bar.getBoundingClientRect();
    glowEl.style.setProperty('--tg-glow-x',(r.left-br.left+r.width/2)+'px');
  }
  function updateBadge(n){if(!badgeEl)return;badgeEl.textContent=n;badgeEl.style.display=n>0?'flex':'none';}

  /* Rimossa la numerazione 01/02/03 sulle voci di menu: "Maison, Estate,
     Harvest, Gifting" non è una sequenza, quindi numerarla non informa
     nulla — è solo un vezzo grafico da template. Restano l'animazione di
     entrata a cascata e il marquee. */
  function enhanceMenu(){
    var items=document.querySelectorAll('#flowingMenu .menu__item');
    if(!items.length)return;
    Array.prototype.forEach.call(items,function(it,i){
      it.style.setProperty('--i',i);
      var stale=it.querySelector('.menu__num');
      if(stale&&stale.parentNode)stale.parentNode.removeChild(stale);
    });
    if(coarse){
      document.addEventListener('touchstart',function(e){
        var l=e.target.closest('.menu__item-link');
        if(!l||typeof window.gsap==='undefined')return;
        var m=l.parentElement.querySelector('.marquee');if(!m)return;
        gsap.set(m,{y:'101%'});gsap.to(m,{y:'0%',duration:.45,ease:'expo'});
      },{passive:true});
    }
  }

  /* ---------- 3 · SHEET post-aggiunta ---------- */
  var sheetEl=null,sheetRefs=null,lastFocus=null;

  function money(cents,currency){
    try{
      return new Intl.NumberFormat(document.documentElement.lang||'it',
        {style:'currency',currency:currency||'EUR'}).format(cents/100);
    }catch(e){return (cents/100).toFixed(2);}
  }

  function buildSheet(){
    if(sheetEl)return sheetRefs;
    var s=el('div','tg-sheet');
    s.setAttribute('role','dialog');
    s.setAttribute('aria-modal','true');
    s.setAttribute('aria-labelledby','tgSheetTitle');
    s.innerHTML=
      '<div class="tg-sheet__scrim" data-tg-close></div>'+
      '<div class="tg-sheet__panel">'+
        '<span class="tg-sheet__eyebrow"></span>'+
        '<p class="tg-sheet__title" id="tgSheetTitle"></p>'+
        '<p class="tg-sheet__meta"></p>'+
        '<div class="tg-sheet__actions">'+
          '<a class="tg-sheet__btn tg-sheet__btn--primary" href="'+ROOT+'/checkout"></a>'+
          '<a class="tg-sheet__btn" href="'+(CFG.cart||ROOT+'/cart')+'"></a>'+
        '</div>'+
        '<button type="button" class="tg-sheet__continue" data-tg-close></button>'+
      '</div>';
    document.body.appendChild(s);
    sheetEl=s;
    sheetRefs={
      eyebrow:s.querySelector('.tg-sheet__eyebrow'),
      title:s.querySelector('.tg-sheet__title'),
      meta:s.querySelector('.tg-sheet__meta'),
      checkout:s.querySelector('.tg-sheet__btn--primary'),
      cart:s.querySelector('.tg-sheet__btn:not(.tg-sheet__btn--primary)'),
      cont:s.querySelector('.tg-sheet__continue')
    };
    sheetRefs.eyebrow.textContent=L.added||'Aggiunto';
    sheetRefs.checkout.textContent=L.checkout||'Vai al checkout';
    sheetRefs.cart.textContent=L.view_cart||'Vedi il carrello';
    sheetRefs.cont.textContent=L.continue_shopping||'Continua a esplorare';

    s.addEventListener('click',function(e){
      if(e.target.closest('[data-tg-close]'))closeSheet();
    });
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'&&s.classList.contains('is-open'))closeSheet();
      if(e.key==='Tab'&&s.classList.contains('is-open'))trapFocus(e);
    });
    return sheetRefs;
  }

  function trapFocus(e){
    var f=sheetEl.querySelectorAll('a[href],button:not([disabled])');
    if(!f.length)return;
    var first=f[0],last=f[f.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
  }

  function openSheet(title,cart){
    var r=buildSheet();
    r.title.textContent=title||'';
    var n=cart.item_count||0;
    r.meta.textContent=n+' '+(n===1?(L.item_one||'articolo'):(L.item_other||'articoli'))+
                       ' · '+money(cart.total_price,cart.currency);
    lastFocus=document.activeElement;
    sheetEl.classList.add('is-open');
    document.body.classList.add('tg-sheet-open');
    if(window.__lenis){try{window.__lenis.stop();}catch(e){}}
    requestAnimationFrame(function(){r.checkout.focus();});
  }

  function closeSheet(){
    if(!sheetEl)return;
    sheetEl.classList.remove('is-open');
    document.body.classList.remove('tg-sheet-open');
    if(window.__lenis){try{window.__lenis.start();}catch(e){}}
    if(lastFocus&&lastFocus.focus){try{lastFocus.focus();}catch(e){}}
  }

  function ajaxAtc(){
    var form=document.querySelector('form.product__form');if(!form)return;
    var titleEl=document.querySelector('.product__title,h1');
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=form.querySelector('[name="add"]');
      var prev=btn?btn.textContent:'';
      if(btn){btn.disabled=true;btn.textContent='···';}
      fetch(ROOT+'/cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}})
        .then(function(r){if(!r.ok)throw new Error('atc');return r.json();})
        .then(function(added){
          return fetch(ROOT+'/cart.js').then(function(r){return r.json();})
            .then(function(c){return {added:added,cart:c};});
        })
        .then(function(d){
          if(btn){btn.disabled=false;btn.textContent=prev;}
          updateBadge(d.cart.item_count);
          openSheet((d.added&&d.added.product_title)||(titleEl?titleEl.textContent.trim():''),d.cart);
        })
        .catch(function(){
          if(btn){btn.disabled=false;btn.textContent=prev;}
          HTMLFormElement.prototype.submit.call(form);
        });
    });
  }

  function buildBuybar(){
    var form=document.querySelector('form.product__form');
    var atc=form?form.querySelector('[name="add"]'):null;
    var priceEl=document.querySelector('.product__price');
    if(!form||!atc||!priceEl)return;
    var bar=el('div','tg-buybar');
    var p=el('div','tg-buybar__price',priceEl.textContent.replace(/\s+/g,' ').trim());
    var b=el('button','tg-buybar__btn',atc.textContent.trim());
    b.type='button';b.disabled=atc.disabled;
    b.addEventListener('click',function(){
      if(form.requestSubmit)form.requestSubmit();
      else form.dispatchEvent(new Event('submit',{cancelable:true,bubbles:true}));
    });
    bar.appendChild(p);bar.appendChild(b);document.body.appendChild(bar);
    form.addEventListener('change',function(){setTimeout(function(){
      p.textContent=priceEl.textContent.replace(/\s+/g,' ').trim();
      b.textContent=atc.textContent.trim();
      b.disabled=atc.disabled;
    },40);});
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        bar.classList.toggle('show',!en[0].isIntersecting&&isMobile());
      },{rootMargin:'-64px 0px 0px 0px'}).observe(atc);
    }else{bar.classList.add('show');}
  }

  function compactWeatherMobile(){
    var el2=document.getElementById('estateNow');if(!el2)return;
    var mq=matchMedia('(max-width:720px)');
    var lastFull=null,obs;
    function compact(){
      var place=el2.dataset.place||'Melito Irpino';
      var icoSpan=el2.querySelector('.w-ico');var ico=icoSpan?icoSpan.innerHTML:'';
      var m=(el2.textContent||'').match(/(-?\d+)°/);
      var temp=m?m[1]+'°':(el2.dataset.temp?Math.round(parseFloat(el2.dataset.temp))+'°':'');
      obs.disconnect();
      el2.innerHTML='<b class="w-place">'+place+'</b> <span class="w-ico">'+ico+'</span> <span class="w-temp">'+temp+'</span>';
      el2.classList.add('estate-now--compact');
      obs.observe(el2,{childList:true,subtree:true,characterData:true});
    }
    function onMutate(){
      if(!el2.classList.contains('estate-now--compact'))lastFull=el2.innerHTML;
      if(mq.matches)compact();
    }
    obs=new MutationObserver(onMutate);
    obs.observe(el2,{childList:true,subtree:true,characterData:true});
    if(!el2.classList.contains('estate-now--compact'))lastFull=el2.innerHTML;
    if(mq.matches)compact();
    function onChange(){
      if(mq.matches){compact();}
      else if(lastFull){obs.disconnect();el2.classList.remove('estate-now--compact');el2.innerHTML=lastFull;obs.observe(el2,{childList:true,subtree:true,characterData:true});}
    }
    if(mq.addEventListener)mq.addEventListener('change',onChange);else if(mq.addListener)mq.addListener(onChange);
  }

  function initScrollHeader(){
    var tb=document.querySelector('.topbar');if(!tb)return;
    var on=false;
    function upd(){
      var s=(window.scrollY||window.pageYOffset||0)>40;
      if(s!==on){on=s;tb.classList.toggle('tg-scrolled',on);}
    }
    window.addEventListener('scroll',upd,{passive:true});
    upd();
  }

  window.__tgUpdateCartBadge=updateBadge;
  window.__tgCloseSheet=closeSheet;
})();
